<template>
    <div>
        <table class="table">
            <tbody>
            <app-list-release-item v-for="item in list" :item="item"></app-list-release-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListReleaseItem from './ListReleaseItem'
  import data from '../../data/products'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListReleaseItem: ListReleaseItem
    }
  }
</script>
